var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"btn-planning"},[_c('el-button',{staticClass:"default",on:{"click":_vm.verify}},[_vm._v("\n      ENVIAR PLANIFICACIÓN\n    ")])],1),_c('DialogSummary',{ref:"summary",on:{"sendPlanning":_vm.sendPlanning}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }